import React from 'react';
import { ReactComponent as QuestionImage } from '../../assets/images/questionImage.svg';

import { IFormDataInPaystatement, IPayItemInPaystatement } from 'types/salary';
import useAlertConfirmStore from '../../zustands/useAlertConfirmStore';

interface IProps {
  NAME: string;
  PAYDATA: IFormDataInPaystatement;
  HandlePayInput: (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void; //금액입력
  HandlePayInput2: (e: React.ChangeEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void; // 시간,분입력
  PAYTYPE: string;
  handlePay: (e: React.KeyboardEvent<HTMLInputElement>, isSecondDefaultPay?: boolean) => void;
  payAutoSum: (isSecondDefaultPay?: boolean) => void;
  AddZeroValue: (NAME: any) => void;
}

const SectionWorkTimeInput = ({
  NAME,
  PAYDATA,
  HandlePayInput, //금액입력
  HandlePayInput2, // 시간,분입력
  PAYTYPE,
  handlePay,
  payAutoSum,
  AddZeroValue,
}: IProps) => {
  let VALUE = PAYDATA[NAME];
  let VALUE2 = PAYDATA[NAME];
  let VALUE3 = PAYDATA[NAME];
  let VALUE4 = PAYDATA[NAME];
  let VALUE5 = PAYDATA[NAME];
  let VALUENAME1 = NAME;
  let VALUENAME2 = '';
  let VALUENAME3 = '';
  let VALUENAME4 = '';
  let VALUENAME5 = '';
  if (NAME == '기본급') {
    if (PAYTYPE == '시급') {
      VALUE = PAYDATA['근무시간'];
      VALUE2 = PAYDATA['근무분'];
      VALUE3 = PAYDATA['시급'];
      VALUE4 = PAYDATA['주휴수당시간'];
      VALUE5 = PAYDATA['주휴수당분'];
      VALUENAME1 = '근무시간';
      VALUENAME2 = '근무분';
      VALUENAME3 = '시급';
      VALUENAME4 = '주휴수당시간';
      VALUENAME5 = '주휴수당분';
    } else if (PAYTYPE == '일급') {
      VALUE = PAYDATA['근무일수'];
      VALUE2 = PAYDATA['일급'];
      VALUENAME1 = '근무일수';
      VALUENAME2 = '일급';
    } else {
      VALUE = PAYDATA['근무시간'];
      VALUE2 = PAYDATA['근무분'];
      VALUENAME1 = '근무시간';
      VALUENAME2 = '근무분';
    }
  }
  if (NAME == '연장근로수당') {
    VALUE = PAYDATA['연장근로시간'];
    VALUE2 = PAYDATA['연장근로분'];
    VALUENAME1 = '연장근로시간';
    VALUENAME2 = '연장근로분';
  }
  if (NAME == '야간근로수당') {
    VALUE = PAYDATA['야간근로시간'];
    VALUE2 = PAYDATA['야간근로분'];
    VALUENAME1 = '야간근로시간';
    VALUENAME2 = '야간근로분';
  }
  if (NAME == '휴일근로수당') {
    VALUE = PAYDATA['휴일근로시간'];
    VALUE2 = PAYDATA['휴일근로분'];
    VALUENAME1 = '휴일근로시간';
    VALUENAME2 = '휴일근로분';
  }
  if (VALUE === undefined) VALUE = '';
  if (VALUE2 === undefined) VALUE2 = '';
  if (VALUE3 === undefined) VALUE3 = '';
  if (VALUE4 === undefined) VALUE4 = '';
  if (VALUE5 === undefined) VALUE5 = '';

  const { setModalState } = useAlertConfirmStore();

  return (
    <div className="SectionPayInput">
      {NAME == '기본급' ? (
        PAYTYPE == '시급' ? (
          <>
            <div className="SectionPayInner">
              <span>시간</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>분</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W30"
                maxLength={2}
                value={VALUE2}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>시급</span>
              <input
                type="text"
                name={VALUENAME3}
                className="W40"
                maxLength={6}
                onChange={HandlePayInput}
                value={VALUE3}
                onKeyUp={handlePay}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <div
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'center',
                  cursor: 'pointer',
                  width: '16px',
                  height: '16px',
                  marginRight: '4px',
                }}
                onClick={() => {
                  setModalState({
                    isModalShow: true,
                    title: '주휴수당',
                    descDiv: (
                      <div>
                        <div
                          style={{
                            fontFamily: 'Pretendard',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            marginBottom: '12px',
                            color: '#737373',
                            textAlign: 'left',
                          }}>
                          주휴수당에 해당하는 모든 근무일의 총 근무 시간을 합산하여 입력해요
                        </div>
                        <section
                          style={{
                            background: '#F5F5F5',
                            padding: '12px',
                            borderRadius: '8px',
                            fontFamily: 'Pretendard',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            marginBottom: '12px',
                            color: '#737373',
                            textAlign: 'left',
                          }}>
                          <p>(예시)</p>
                          <p>직원 홍길동의 6월 근무내역</p>

                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '4px',
                              marginBottom: '8px',
                            }}>
                            <div>{`·`}</div>
                            <p>
                              정규 근무 : 월 ~ 목 주 4회, 일 5시간 (4주)
                              <br />
                              4일 x 5시간 x 4주 =<strong style={{ marginLeft: '4px' }}>80시간</strong>
                            </p>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '4px',
                              marginBottom: '12px',
                            }}>
                            <div>{`·`}</div>
                            <p>
                              주말 추가 근무 : 토요일 1회, 일 3시간
                              <br />
                              (소정근로 기준 산정하기 때문에 일시적인 추가 근무는 주휴수당에 포함되지 않아요)
                            </p>
                          </div>
                          <div
                            style={{
                              display: 'flex',
                              alignItems: 'flex-start',
                              gap: '4px',
                              marginBottom: '12px',
                            }}>
                            <strong>{`·`}</strong>
                            <strong>주휴수당 총 시간 : 80시간</strong>
                          </div>
                        </section>
                        <div
                          style={{
                            fontFamily: 'Pretendard',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                            letterSpacing: '0%',
                            marginBottom: '12px',
                            color: '#737373',
                            textAlign: 'left',
                          }}>
                          또한, 결근이 있는 주는 주휴수당에 해당 하지 않기 때문에 제외해요{' '}
                        </div>
                      </div>
                    ),
                    okBtnText: '확인',
                  });
                }}>
                <QuestionImage />
              </div>
              <span>주휴수당시간</span>
              <input
                type="text"
                name={VALUENAME4}
                className="W30"
                maxLength={3}
                value={VALUE4}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>주휴수당분</span>
              <input
                type="text"
                name={VALUENAME5}
                className="W30"
                maxLength={3}
                value={VALUE5}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
          </>
        ) : PAYTYPE == '일급' ? (
          <>
            <div className="SectionPayInner">
              <span>근무일수</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={() => payAutoSum()}
              />
            </div>
            <div className="SectionPayInner">
              <span>일급</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W50"
                maxLength={8}
                onChange={HandlePayInput}
                value={VALUE2}
                onKeyUp={handlePay}
                onBlur={() => payAutoSum()}
              />
            </div>
          </>
        ) : (
          <>
            <div className="SectionPayInner">
              <span>시간</span>
              <input
                type="text"
                name={VALUENAME1}
                className="W30"
                maxLength={3}
                value={VALUE}
                onChange={HandlePayInput2}
                onBlur={AddZeroValue}
              />
            </div>
            <div className="SectionPayInner">
              <span>분</span>
              <input
                type="text"
                name={VALUENAME2}
                className="W30"
                maxLength={2}
                value={VALUE2}
                onChange={HandlePayInput2}
                onBlur={AddZeroValue}
              />
            </div>
          </>
        )
      ) : (
        <>
          <div className="SectionPayInner">
            <span>시간</span>
            <input
              type="text"
              name={VALUENAME1}
              className="W30"
              maxLength={3}
              value={VALUE}
              onChange={HandlePayInput2}
              onBlur={AddZeroValue}
            />
          </div>
          <div className="SectionPayInner">
            <span>분</span>
            <input
              type="text"
              name={VALUENAME2}
              className="W30"
              maxLength={2}
              value={VALUE2}
              onChange={HandlePayInput2}
              onBlur={AddZeroValue}
            />
          </div>
        </>
      )}
    </div>
  );
};

export default SectionWorkTimeInput;
